/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Not_A_DraftInputs */

const en_us2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is the plan you are following, not a draft.`)
};

const pt_br2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse é o plano que você está seguindo, não um rascunho.`)
};

const es_419_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese es el plan que estás siguiendo, no un borrador.`)
};

const pt_pt2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse é o plano que estás a seguir, não um rascunho.`)
};

const fr_fr2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est le programme que tu suis, pas un brouillon.`)
};

const de_de2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist der Plan, dem du folgst, kein Entwurf.`)
};

const it_it2_plan_not_a_draft = /** @type {(inputs: Plan_Not_A_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa è la scheda che stai seguendo, non una bozza.`)
};

/**
* | output |
* | --- |
* | "That is the plan you are following, not a draft." |
*
* @param {Plan_Not_A_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_not_a_draft = /** @type {((inputs?: Plan_Not_A_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Not_A_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_not_a_draft(inputs)
	if (locale === "es-419") return es_419_plan_not_a_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_not_a_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_not_a_draft(inputs)
	if (locale === "de-DE") return de_de2_plan_not_a_draft(inputs)
	if (locale === "it-IT") return it_it2_plan_not_a_draft(inputs)
	return en_us2_plan_not_a_draft(inputs)
});
export { plan_not_a_draft as "plan.not_a_draft" }